<template>
    <b-list-group v-if="tradePoints.length" class="trade-points-list-group">

        <b-list-group-item button  
                           :id="`trade-point-item-${index}`"
                           v-for="(item, index) in tradePoints"
                           :key="index"
                           @click="uploadInformation(item)"
                           class="list-item-TT">
            
            <b-row>

                <b-col cols="1">
                    <b-img :src="`/img/map_marker${item.Type.Id}${item.IsPriceMonitoring ? '_pm' : ''}.png`" />
                </b-col>

                <b-col>
                    <b-row class="text modal-employeeTT-container-employee-name">
                        <b-col class="p-0">
                            {{item.Name}}             
                        </b-col>
                        <b-col cols="1" :id="`tt-location-${index}`" class="list-tt-location cursor-pointer" @click.stop="openNavigator(item)">
                            <font-awesome-icon icon="location-arrow"/>
                        </b-col>
                    </b-row>
                    <b-row class="p-0 text modal-employeeTT-container-employee-position">{{item.Address}}</b-row>
                </b-col>

            </b-row>

        </b-list-group-item> 

    </b-list-group>

    <b-container v-else style="margin-top: 40vh;">
        <b-row class="center">
            <font-awesome-icon icon="store-alt" color="#c7c7c7" size="5x"/>
        </b-row>
        <b-row class="center first-level">
            Торговые точки отсутствуют
        </b-row>
    </b-container>

</template>

<script>
import '@/assets/styles/client/tradePoints/listTradePoints.css'

export default {
    props: {
        tradePoints: {
                type: [Object, Array],
                default: null
            }
        },
    methods: {
        uploadInformation: function(item) {
            this.$emit('select', item);
        },
        openNavigator: function(item) {
            window.open(`https://yandex.ru/maps/?text=${item.Position.lat}%2C%20%20${item.Position.lng}`);
        }
    }
}
</script>